module.exports = __webpack_public_path__ + "img/trainingDays.8583e69e.svg";